module.exports = __webpack_public_path__ + "img/green-home.c48890e0.svg";